<app-header></app-header>
<router-outlet></router-outlet>
<div class="z-fg relative md:absolute bottom-0 left-0 right-0">
  <app-footer></app-footer>
</div>
